import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Layout from "../layout/auth";
import { login } from "../../lib/actions/authAction";
import LoginForm from "../../components/login/LoginForm";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { push } from "connected-react-router";

class Home extends React.Component {
  render() {
    const centerStyle = {
      height: "100vh",
      alignItems: "center"
    };

    return (
      <Layout>
        <Row className="justify-content-center" style={centerStyle}>
          <Col md={5}>
            <Card className="border-0 mb-0 shadow">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <small>FD Media Editor Login</small>
                </div>
                <LoginForm {...this.props} />
              </CardBody>
            </Card>
            <Row className=" mt-3">
              <Col className="text-center">
                <Button
                  color="link"
                  className="text-white"
                  onClick={this.props.goForgotPassword}
                >
                  <small>忘记密码?</small>
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      handleLogin: (email, password) => login(email, password),
      goForgotPassword: email => push("/password/forgot")
    },
    dispatch
  );

const mapStateToProps = state => {
  const { authReducer } = state;
  return {
    authReducer
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
